<template>
  <div>
    <div class="relative flex justify-center items-center">
      <div class="absolute z-30 font-serif text-white px-6">
        <div data-aos="fade-bottom" class="h-24 md:h-32 w-full flex justify-center mb-4">
          <nuxt-img sizes="xl:100vw lg:100vw md:100vw sm:100vw xs:100vw" class="h-full cursor-pointer -p-[10px]" src="/images/logo_bianco.png"/>
        </div>
        <div data-aos-duration="700" data-aos-delay="200" data-aos="zoom-in-right"
          class="opacity-0 text-4xl md:text-5xl leading-[50px] md:leading-[60px] text-center">{{ $t('home.citation') }}</div>
        <div data-aos-duration="700" data-aos-delay="200" data-aos="zoom-in-left"
          class="opacity-0 text-sm md:text-base w-full font-thin mt-3 text-center md:text-right italic">– Martin Buber</div>
      </div>
      <div class="absolute z-20 inset-0 bg-black opacity-40"></div>
      <nuxt-img sizes="xl:100vw lg:100vw md:100vw sm:100vw xs:100vw" class="object-cover object-center min-h-[400px] w-full md:aspect-[2.5]"
        src="/images/home.jpg"/>
    </div>
    <HomeAboutUs></HomeAboutUs>
    <HomeNews></HomeNews>
    <HomeServices></HomeServices>
    <HomeEvents></HomeEvents>
    <HomeReviews></HomeReviews>
  </div>
</template>

<script setup>
</script>

<style scoped></style>